import React, { useState, useEffect, useContext } from 'react';
import { Container, Card, Table, Button, Badge } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import Alert from './common/Alert';
import { fetchSubscriptions, renewSubscription } from '../services/subscriptions';

const Subscription = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const loadSubscriptions = async () => {
      try {
        const data = await fetchSubscriptions(user.token);
        setSubscriptions(data);
      } catch (err) {
        setError('Errore nel caricamento degli abbonamenti');
      }
    };
    if (user) loadSubscriptions();
  }, [user]);

  const handleRenew = async (subscriptionId) => {
    setError('');
    setSuccess('');
    try {
      const response = await renewSubscription(subscriptionId, user.token);
      setSuccess(response.message);
      const data = await fetchSubscriptions(user.token);
      setSubscriptions(data);
    } catch (err) {
      setError('Errore nel rinnovo dell\'abbonamento');
    }
  };

  return (
    <Container className="py-4">
      <Card>
        <Card.Header className="bg-white">
          <h5 className="mb-0">I miei abbonamenti</h5>
        </Card.Header>
        <Card.Body>
          <Alert variant="danger" message={error} />
          <Alert variant="success" message={success} />
          <Table responsive hover>
            <thead className="bg-light">
              <tr>
                <th>Piano</th>
                <th>Data di inizio</th>
                <th>Data di scadenza</th>
                <th>Stato</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.map((sub) => (
                <tr key={sub._id}>
                  <td>{sub.productId.title}</td>
                  <td>{new Date(sub.startDate).toLocaleDateString()}</td>
                  <td>{new Date(sub.endDate).toLocaleDateString()}</td>
                  <td>
                    <Badge bg={sub.status === 'active' ? 'success' : 'danger'}>
                      {sub.status === 'active' ? 'Attivo' : 'Scaduto'}
                    </Badge>
                  </td>
                  <td>
                    {sub.status !== 'active' && (
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleRenew(sub._id)}
                      >
                        Rinnova
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Subscription;